module.exports = __webpack_public_path__ + "media/images/sauna_bg-f6cda4b921860641dc8af76e33b86f58.jpg";